<template>
  <div>
    <div class="time-count" v-if="dateNumb.length > 0 && dateNumb.length > 6">
      <div>{{ dateNumb[0] }}{{ dateNumb[1] }}{{ dateNumb[2] }}</div>
      <div>{{ dateNumb[3] }}{{ dateNumb[4] }}</div>
      <div>{{ dateNumb[5] }}{{ dateNumb[6] }}</div>
    </div>
    <div class="time-count" v-else>
      <div>{{ dateNumb[0] }}{{ dateNumb[1] }}</div>
      <div>{{ dateNumb[2] }}{{ dateNumb[3] }}</div>
      <div>{{ dateNumb[4] }}{{ dateNumb[5] }}</div>
    </div>
  </div>
</template>
<script>
import * as Time from "~/assets/libs/timeOptions";
export default {
  name: "count-down",
  data() {
    return {
      date: Time.checkDateType(this.endDate)
    };
  },
  props: {
    endDate: {
      type: [String, Object, Date, Number],
      default: null
    },
    types: {
      type: [String],
      default: "home"
    },
    lottery: {
      type: [Object],
      default: null
    }
  },
  watch: {
    endDate() {
      this.date = Time.checkDateType(this.endDate);
    }
  },
  mounted() {
  },
  computed: {
    //当前服务器时间
    leftTime() {
      return Time.checkDateType(this.$store.getters["service/getServiceTime"]);
    },
    dateNumb() {
      if (this.leftTime.getTime() == 0) {
        console.log(this.leftTime)
        return `000000`;
      }
      //结束时间 - 当前时间
      if (this.date == null) return `000000`;

      let lastTime = this.date.getTime() - this.leftTime.getTime();
      if (lastTime <= 0) {
        this.$emit("endCountDown", this.date);
        return `000000`;
      }
      //没有天 所以不%24
      // var hours = parseInt(lastTime / (1000 * 60 * 60) % 24 , 10); //计算剩余的小时
      var hours = parseInt(lastTime / (1000 * 60 * 60), 10); //计算剩余的小时
      var minutes = parseInt((lastTime / 1000 / 60) % 60, 10); //计算剩余的分钟
      var seconds = parseInt((lastTime / 1000) % 60, 10); //计算剩余的秒数

      if (hours <= 9) hours = `0${hours}`;
      if (minutes <= 9) minutes = `0${minutes}`;
      if (seconds <= 9) seconds = `0${seconds}`;

      // console.log('time:',`${hours}:${minutes}:${seconds}`)

      return `${hours}${minutes}${seconds}`;
    },
    // 开奖中
    LotteryLatelyLpVo() {
      if (this.lottery) {
        return this.lottery.drawingNumber
          ? this.lottery.drawingNumber.split(",")
          : [];
      } else {
        return [];
      }
    }
  },
  created() {
    // this.$store.dispatch("service/getServiceTime"); // 获取服务器时间
  }
};
</script>

<style lang="less" scoped></style>
